import { render } from "./Today.vue?vue&type=template&id=4c755a00&lang=pug"
import script from "./Today.vue?vue&type=script&lang=js"
export * from "./Today.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__